import type { ChannelTestResultEntry } from './ChannelSidePanel';
import { Button } from '../Button';

interface ChannelTestResultsTabProps {
  testResults: ChannelTestResultEntry[];
  onSendTestNotification: () => Promise<void>;
  isSendingTestNotification: boolean;
}

const formatDateTime = (timestamp: string) =>
  new Date(timestamp).toLocaleString('en-GB');

export function ChannelTestResultsTab({
  testResults,
  onSendTestNotification,
  isSendingTestNotification,
}: ChannelTestResultsTabProps) {
  if (testResults.length === 0) {
    return (
      <div className='flex flex-col gap-3 px-6 py-4'>
        <div>
          <Button
            variant='secondary'
            state={isSendingTestNotification ? 'disabled' : 'default'}
            onClick={() => {
              void onSendTestNotification();
            }}
          >
            {isSendingTestNotification ? 'Sending test...' : 'Send test notification'}
          </Button>
        </div>
        <div className='size-p2 text-secondary'>
          No test notifications have been sent for this channel yet.
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col gap-3 px-6 py-4'>
      <div>
        <Button
          variant='secondary'
          state={isSendingTestNotification ? 'disabled' : 'default'}
          onClick={() => {
            void onSendTestNotification();
          }}
        >
          {isSendingTestNotification ? 'Sending test...' : 'Send test notification'}
        </Button>
      </div>

      {testResults.map((result) => (
        <div
          key={result.id}
          className='border-border-primary rounded border bg-surface-primary px-4 py-3'
        >
          <div className='mb-2 flex items-center justify-between gap-3'>
            <span
              className={
                result.status === 'success'
                  ? 'size-caption text-success font-medium'
                  : 'size-caption text-error font-medium'
              }
            >
              {result.status === 'success' ? 'Sent' : 'Failed'}
            </span>
            <span className='size-caption text-tertiary'>
              {formatDateTime(result.timestamp)}
            </span>
          </div>
          <p className='size-p2 text-primary'>{result.message}</p>
        </div>
      ))}
    </div>
  );
}


